import React, { useState, useEffect, Fragment, useImperativeHandle, forwardRef } from "react";
import styled from "styled-components";
import { post } from "../../lib/Fetching";
import { findSamples } from "./FetchTrays";
import Samples from "../sample_reporting/Samples";
import TraySampleActionBar from "./TraySampleActionBar";
import Button from "../Button";
import { getDueDate, formattedDueDate, lastStateChangeF } from "../../lib/trays/TrayUtils";
import classNames from "classnames";

const Container = styled.div`
  border: 1px solid #ccc;
  width: 100%;
  border-radius: 0px;
  margin-right: 20px;
  margin-bottom: 20px;

  > .toolbar {
    padding: 15px;
    padding-bottom: 10px;
    padding-top: 10px;
    display: flex;
    justify-content: flex-start;
    > div {
      margin-right: 15px;
      padding-right: 15px;
      border-right: 1px solid #ddd;
    }
  }

  > .heading {
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    .count {
      background-color: #6bff6b;
      color: black;
      padding: 15px;
      padding-left: 20px;
      padding-right: 20px;
      font-size: 14pt;
    }
    .text {
      padding: 12px;
      font-size: 14pt;
      font-weight: bold;
      text-align: center;
    }
  }
`;

const Tray = forwardRef(({ tray, active, style, removeTray, reloadTray }, ref) => {
  const [generation, setGeneration] = useState(0);
  const [sampleList, setSampleList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [allowPreviouslyScheduledSamples, setAllowPreviouslyScheduledSamples] = useState(
    false
  );

  const fetchSamples = () => {
    findSamples(tray.id).then((sampleList) => {
      setSampleList(sampleList);
      setGeneration(generation + 1);
    });
  };

  const reloadData = () => {
    reloadTray && reloadTray();
    fetchSamples();
  };

  useImperativeHandle(ref, () => ({
    reloadSamples() {
      fetchSamples();
    },
  }));

  useEffect(() => {
    fetchSamples();
  }, []);
  // const dueDate = getDueDate(tray);
  // const dueDateOutput = formattedDueDate(tray);

  const handleScheduleTray = () => {
    if (!confirm("Are you sure you want to schedule these samples?")) return;
    setLoading(true);
    post("/trays/trays/" + tray.id + "/schedule_tray.json", {
      allow_scheduled_samples: allowPreviouslyScheduledSamples,
    }).then((json) => {
      setLoading(false);
      if (json.errors) {
        alert(json.errors);
      } else {
        alert("All Samples were scheduled");
        removeTray && removeTray();
      }
      fetchSamples();
    });
  };

  const handleDiscardTray = () => {
    if (!confirm("Are you sure you want to empty and discard this tray?")) return;
    setLoading(true);
    post("/trays/trays/" + tray.id + "/discard_tray.json").then((json) => {
      setLoading(false);
      if (json.errors) {
        alert(json.errors);
      } else {
        removeTray && removeTray();
      }
      fetchSamples();
    });
  };

  return (
    <Container
      active={active}
      style={style}
      item_count={tray.item_count || 0}
      className={classNames({
        fully_reported: tray.fully_reported,
        active,
        fully_reported: tray.fully_reported,
      })}
    >
      <div className="toolbar">
        <div>
          <b>{tray.item.name}</b>
        </div>
        <div>{tray.item_count} samples</div>
        <div>Location: {tray.parent_location_name}</div>
        <div>
          <a href={"/tracking/items/" + tray.item.id} target="_blank">
            View Item Details
          </a>
        </div>
        <div>
          State:&nbsp;
          <b>{tray.state}</b>
        </div>
      </div>
      <div className="toolbar">
        {tray.permitted_states.includes("scheduled") && (
          <div>
            <Button
              title="Schedule All Samples"
              disabled={loading}
              primary
              icon={loading ? "fa-spinner fa-spin" : null}
              onClick={handleScheduleTray}
            />
            &nbsp;&nbsp;
            <input
              type="checkbox"
              value={allowPreviouslyScheduledSamples}
              onChange={() =>
                setAllowPreviouslyScheduledSamples(!allowPreviouslyScheduledSamples)
              }
            />
            &nbsp; Allow previously scheduled samples?
          </div>
        )}
        {(tray.permitted_states.includes("discarded") ||
          tray.permitted_states.includes("available")) && (
          <Button
            title="Discard Tray"
            disabled={loading}
            primary
            icon={loading ? "fa-spinner fa-spin" : null}
            onClick={handleDiscardTray}
          />
        )}
      </div>
      {!sampleList && <div style={{ padding: 20 }}>Loading...</div>}
      {sampleList &&
        sampleList.samples.length === 0 && <div style={{ padding: 20 }}>No Samples</div>}
      {sampleList &&
        sampleList.samples.length > 0 && (
          <div style={{ zoom: 1.1, padding: 15, paddingTop: 0 }}>
            <Samples
              key={generation}
              sample_list={sampleList}
              clientView={false}
              showAttributes={false}
              reloadData={reloadData}
              ToolbarComponent={TraySampleActionBar}
              ToolbarComponent2={null}
              toolbarOptions={{ tray, onScheduled: removeTray }}
            />
          </div>
        )}
    </Container>
  );
});

export default Tray;
